import { render, staticRenderFns } from "./PconEditAppr.vue?vue&type=template&id=55ff20ad&scoped=true&"
import script from "./PconEditAppr.vue?vue&type=script&lang=js&"
export * from "./PconEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff20ad",
  null
  
)

export default component.exports